var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationOutlineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6243 8.09065V7.50349C15.6243 4.27954 13.1062 1.66602 10 1.66602C6.8938 1.66602 4.37573 4.27954 4.37573 7.50349V8.09065C4.37573 8.79531 4.17476 9.4842 3.79817 10.0705L2.8753 11.5073C2.03235 12.8196 2.67587 14.6034 4.14197 15.0184C7.97728 16.1041 12.0227 16.1041 15.858 15.0184C17.3241 14.6034 17.9676 12.8196 17.1247 11.5073L16.2018 10.0705C15.8252 9.4842 15.6243 8.79531 15.6243 8.09065Z",
    stroke: "#1C274C",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6.25 15.834C6.79586 17.2905 8.26871 18.334 10 18.334C11.7313 18.334 13.2041 17.2905 13.75 15.834",
    stroke: "#1C274C",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOutlineIcon);
export default __webpack_public_path__ + "static/media/notification-outline-icon.df69285309d7d8569907b7477ae8c871.svg";
export { ForwardRef as ReactComponent };